{
  "$schema": "http://json-schema.org/draft-07/schema",
  "$id": "InviteDefinition",
  "definitions": {
    "InviteSchema": {
      "type": "object",
      "required": [
        "id",
        "created_by",
        "created_at",
        "deleted_by",
        "deleted_at",
        "type",
        "expires_at",
        "invited_by",
        "data",
        "profile_id"
      ],
      "additionalProperties": false,
      "properties": {
        "id": {
          "type": "string",
          "format": "uuid"
        },
        "created_by": {
          "type": "string"
        },
        "created_at": {
          "type": "string",
          "format": "date-time"
        },
        "deleted_by": {
          "type": ["string", "null"],
          "format": "uuid"
        },
        "deleted_at": {
          "type": ["string", "null"],
          "format": "date-time"
        },
        "type": {
          "type": "string",
          "enum": ["golden_ticket", "connect_student"]
        },
        "expires_at": {
          "type": "string",
          "format": "date-time"
        },
        "sent_at": {
          "type": "string",
          "format": "date-time"
        },
        "activated_by": {
          "type": "string"
        },
        "activated_at": {
          "type": "string",
          "format": "date-time"
        },
        "invited_by": {
          "description": "The name of the person or organisation the invite sent from",
          "type": "string",
          "minLength": 2
        },
        "data": {
          "oneOf": [
            {
              "$ref": "#/definitions/ConnectStudentInvite"
            },
            {
              "$ref": "#/definitions/GoldenTicketInvite"
            }
          ]
        },
        "profile_id": {
          "type": "string"
        }
      }
    },
    "GoldenTicketInvite": {
      "type": "object",
      "required": [],
      "additionalProperties": false,
      "properties": {
        "email": {
          "type": "string",
          "format": "email"
        }
      }
    },
    "ConnectStudentInvite": {
      "type": "object",
      "required": ["student_id"],
      "additionalProperties": false,
      "properties": {
        "student_id": {
          "type": "string"
        }
      }
    }
  }
}
